import { createSelector } from 'reselect';

var createCurrentLayoutSelector = function createCurrentLayoutSelector() {
  return createSelector(function (layouts) {
    return layouts;
  }, function (layouts) {
    var currentLayout = layouts === null || layouts === void 0 ? void 0 : layouts.find(function (l) {
      return l.selected;
    });
    if (!currentLayout) {
      return undefined;
    }
    return {
      currentLayout: currentLayout
    };
  });
};

export { createCurrentLayoutSelector };
//# sourceMappingURL=current-layout-selector.esm.js.map
